export const UserRole = Object.freeze({
    Admin: 'admin',
});
